<template>
  <div class="findDetail" ref="findDetail">
    <communityHeader :router_url='router_url'></communityHeader>

    <div class="contentWidth">
      <div class="location"><a href="#">中经视觉社区</a> &gt;
        <router-link :to="'/community/'">
          发现
        </router-link> &gt;
        <span>作品详情</span>
      </div>
      <div class="of_h context">
        <div class="fc_l left">
          <div v-show="loading">
            <loading></loading>
          </div>
          <div v-show="!loading">
            <div class="article">
              <div class="title anmition_show"> {{ worksdetail.topic.title }}</div>
              <div class="userinfo of_h anmition_show">
                <div class="photo fc_l">
                  <a href="javascript:;"
                     @click="on_ucenter(worksdetail.topic.authorId)">
                    <img v-if="worksdetail.topic.headimg"
                         :src="worksdetail.topic.headimg">
                    <img v-else
                         src="@/assets/image/community/nophoto.png">
                  </a>
                </div>

                <div class="info fc_l of_h">
                  <div class="name"
                       v-if="worksdetail.topic.realname">{{worksdetail.topic.realname}}</div>
                  <div class="name"
                       v-if="!worksdetail.topic.realname">暂无昵称</div>

                  <div class="time" v-if="worksdetail.topic.createTime">
                    发布于 <span v-time="worksdetail.topic.createTime"></span>
                  </div>
                  <!-- <div class="time">
                    <strong>{{worksdetail.topic.createTime | getMoment }}</strong>
                  </div> -->

                </div>

                <div class="state fc_r">
                  <ul>
                    <!-- 预览 -->
                    <li @click="getScroll()"
                        title="浏览"><i></i>{{worksdetail.topic.viewCount}}</li>

                    <!-- 评论 -->
                    <li @click="getScroll()"
                        title="评论"
                        class="common"><i></i>{{worksdetail.topic.replyCount}}
                    </li>
                    <!-- 未点赞 -->
                    <li class="like_son"
                        title="点赞"
                        @click="favorfn(worksdetail.topic.topicId)">
                      <!-- 点赞 -->
                      <div class="width"
                           v-if="worksdetail.isFavor==0 || worksdetail.isFavor==null">
                        <i></i>{{worksdetail.topic.favorCount}}
                      </div>
                      <!-- 已点赞 -->
                      <div class="width"
                           v-if="worksdetail.isFavor==1">
                        <i class="like"></i>{{worksdetail.topic.favorCount}}
                      </div>
                    </li>
                    <!-- 分享 -->

                    <li @click="getScroll()"
                        title="分享"
                        class="share"><i><img src="../../../assets/image/community/finddetailshare.png"></i></li>

                  </ul>
                </div>

              </div>

              <div class="context_txt anmition_show">
                <div class="imglist">
                  <p>{{worksdetail.topic.description}}</p>
                </div>

                <!-- 详情内容 -->
                <div class="imglist anmition_show"
                     v-for="(topicimg,index) in worksdetail.topicTnList"
                     :key="index">
                  <div class="img fade_image_out">
                    <img v-lazy="topicimg.topicUrl"
                         v-if="topicimg.type ==1"
                         @click="showImgPreview(index)"
                         class="fade_image_out">
                     <!-- <el-image 
                      :lazy="true"
                      class="fade_image_out"
                      :src="topicimg.topicUrl"
                      v-if="topicimg.type ==1"
                      :preview-src-list="previewList">
                    </el-image> -->
                    <video :src="topicimg.topicUrl"
                           v-if="topicimg.type ==2"
                           class="fade_image_out"
                           controls="controls"
                           loop="loop"
                           width="100%"></video>
                  </div>
                  <p>{{topicimg.description}}</p>
                </div>

                <!-- 点赞 全部
                      
                -->
                <button class="nodianza"
                        :disabled="isDisable"
                        @click="favorfn(worksdetail.topic.topicId)">
                  <div class="like_tips _width">
                    <!-- 未点赞 -->
                    <div v-if="worksdetail.isFavor==0 || worksdetail.isFavor==null"
                         @mouseenter=" shareicon=1"
                         @mouseleave="shareicon = 0">
                      <img src="@/assets/image/community/like1.png"
                           class="fade_image_out" />
                      <img src="@/assets/image/community/like2.png"
                           class="hide_tab fade_image_out"
                           :class="shareicon == 1 ?'show_icon':''" />
                    </div>
                    <!-- 点赞 -->
                    <div v-if="worksdetail.isFavor==1"
                         class="fade_image_out">
                      <img src="@/assets/image/community/like3.png"
                           :class="like_style ==true ?'huang':''"
                           class="fade_image_out" />
                      <!-- 扩散 -->
                      <div>
                        <span class="border xiao"></span>
                        <span class="border zhong"></span>
                        <span class="border da"></span>
                      </div>

                    </div>
                    <div class="zashu">{{worksdetail.topic.favorCount}}</div>
                  </div>

                  <!-- 背景 -->
                  <div class="bag"></div>

                </button>
                <!-- 点赞 全部end-->

                <div v-if="zaUsers>0">
                  <div class="signatory">-{{zaUsers.length}}位签约摄影师推荐-</div>
                  <div class="signatorys">
                    <div class="signer"
                         v-for="(user,index) in zaUsers"
                         :key="index">
                      <img :src="user.headimg">
                    </div>

                    <div class="more"
                         v-if="zaUsers.length>22">{{zaUsers.length-22}}</div>
                  </div>
                </div>

                <div class="share"
                     id="share">
                  <span>分享到：</span>
                  <a href="javascript:;"
                     @click="share_qq"
                     target="_blank"><img src="@/assets/image/community/qq.png"></a>
                  <a href="javascript:;"
                     class="sharewb">
                    <img src="@/assets/image/community/weixin.png"
                         @mouseover="wecodeSp=true"
                         @mouseout="wecodeSp=false">
                    <div class="wecodeSp"
                         id="qrcodes"
                         ref="qrcodeContainers"
                         v-show="wecodeSp">
                    </div>
                  </a>
                  <a href="javascript:;"
                     @click="share_wb"><img src="@/assets/image/community/sinaweb.png"></a>
                </div>
              </div>
            </div>

            <div class="commentsBd"
                 id="commentsBd">
              <div class="edit_comment pd_15 of_h">
                <div class="entry of_h">
                  <div class="photo fc_l"
                       v-if="is_show_common == false"
                       @click="on_ucenter(isLogin_user.id)">
                    <img v-if="isLogin_user.headimg"
                         :src="isLogin_user.headimg">
                  </div>

                  <div class="photo fc_l"
                       v-if="is_show_common == true">
                    <img src="@/assets/image/common/nan.png">
                  </div>

                  <div class="edit fc_l">
                    <textarea placeholder="说点什么"
                              v-model="commentNr"></textarea>
                    <div class="null_login_common"
                         v-if="is_show_common == true">请<a href="javascript:;"
                         @click="on_login()"
                         v-ripple="'rgba(255, 255, 255, 0.25)'">登录</a> 后再进行评论
                    </div>
                  </div>
                </div>
                <div class="submitBtn mt_15 of_h">
                  <button type="button"
                          :class="commentNr?'fc_r on':'fc_r'"
                          @click="submitComment(worksdetail.topic.topicId)">评论</button>
                </div>
              </div>

              <div class="comments">
                <div class="title">全部评论<strong>{{worksdetail.topic.replyCount}}</strong></div>
                <div class="content">

                  <div class="box mt_15 of_h"
                       v-for="(replis,index) in comments"
                       :key="index">
                    <div class="photo fc_l">

                      <div @click="on_ucenter(replis.userReply)">
                        <img v-if="replis.headimg"
                             :src="replis.headimg">
                        <img v-else
                             src="@/assets/image/common/nan.png"
                             alt="">
                      </div>

                    </div>
                    <div class="info fc_l">
                      <div class="name">{{replis.realname}}</div>
                      <div class="context">
                        {{replis.replyContent}}
                      </div>
                      <!-- <div class="time">
                        <strong>{{replis.createTime | getMoment }}</strong>
                      </div> -->

                      <div class="time">
                        <strong v-if="replis.createTime"
                                v-time="replis.createTime"></strong>
                      </div>

                    </div>
                  </div>
                  <div class="morecomments"
                       @click="morecomments(worksdetail.topic.topicId)"
                       v-show="comments.length< worksdetail.topic.replyCount">加载更多评论...</div>
                  <div class="nocomments"
                       v-show="comments.length > worksdetail.topic.replyCount || comments.length == worksdetail.topic.replyCount">
                    没有更多评论了</div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fc_r right">
          <div class="of_h">
            <TAcircle></TAcircle>
          </div>
          <div class="mt_15">
            <relatedWorks></relatedWorks>
          </div>
          <div class="mt_15">
            <recommend></recommend>
          </div>
          <div class="mt_15">
            <intelligent></intelligent>
          </div>
        </div>
      </div>

    </div>
    <image-preview-dialog ref="imagePreviewDialog" :previewList="previewList" :showImgInd="showImgInd" ></image-preview-dialog>
  </div>
</template>

<script>
import communityHeader from '@/components/community/common/communityHeader.vue'
import loading from '@/components/loading/loading.vue'
import TAcircle from '@/components/community/TAcircle/TAcircle'
import relatedWorks from '@/components/swiper/relatedWorks'
import recommend from '@/components/swiper/recommend'
import intelligent from '@/components/community/intelligent/intelligent'
import imagePreviewDialog from '@/components/common/image_preview_dialog.vue'
import {
  topicDetail,
  selectCircleByAuthorId,
  zaUserLevel
} from '@/utils/api/findDetail.js'
import {
  favorTopic,
  selectReplise,
  replyTopic,
  integral
} from '@/utils/api/circleDetail.js'
import { Info } from '@/utils/api/login.js'
import { getMoment } from '@/modules/time.js'
import '@/modules/time2.js'

import {
  socialShare, formatDate
} from '@/modules/common.js'



export default {
  name: "findDetail",
  components: {
    communityHeader,
    loading,
    TAcircle,
    relatedWorks,
    recommend,
    intelligent,
    imagePreviewDialog
  },
  data () {
    return {
      shareicon: 0, //点赞icon默认显示
      loading: true,
      worksdetail: {
        circleId: "",
        isFavor: "0",
        topic: {
          auditorContent: "",
          authorId: "",
          circleId: "",
          collectionCount: 0,
          createTime: "",
          description: "",
          favorCount: 0,
          forumId: "",
          handleTime: "",
          hasImage: 1,
          hasVideo: "",
          headimg: "",
          id: "",
          isChecked: 1,
          isTop: 0,
          lastTime: "",
          rbacId: "",
          realname: "",
          replyCount: 0,
          sortNo: "",
          tags: "",
          title: "",
          topTime: "",
          topicId: "",
          topicTnList: [],
          type: "",
          viewCount: 0,
        }
      },
      zaUsers: [],
      commentNr: "",
      comments: [],
      commentsparames: {
        topicId: "",
        current: 1,
        size: 3
      },
      //用户
      user: {
        headimg: "",
        id: "",
        realname: ""
      },
      //分享
      wecodeSp: false,
      share: {},
      url: '', // 分享的地址  二维码地址

      pltag: 0,
      like_style: false,
      topicId: '',
      isLogin_user: [],
      isDisable: false,//防止重复提交
      isLogin_user: {},
      is_show_common: true,
      previewList: [], // 详情图片预览列表
      isShowImagePreview: true,
      showImgInd: 0,
      imgModal: false
    }
  },
  computed: {
    dateValue () {
      return (val) => {
        // console.log(val);
        return this.$moment(val).fromNow();

      }
    }
  },
  //注册过滤器
  filters: {
    getMoment
  },
  created () {
    // console.log(this.getFormatTime);
    this.router_url = this.$route.fullPath;
    //获取当前用户信息
    this.user.headimg = sessionStorage.getItem("headimg");
    this.user.realname = sessionStorage.getItem("realname");
    this.commentsparames.topicId = this.$route.params && this.$route.params.id;
    this.is_login();//是否登陆
    this.topicId = this.$route.params.id
    let params_data = {
      topicId: this.topicId,
    }
    this.getTopicDetail(params_data);//获取作品详情
    // this.userid = sessionStorage.getItem("id");

  },
  mounted () {

    this.getSelectReplise(this.commentsparames);//获取评论

    this.$nextTick(function () {
      this.showQRCodes();
    })
  },
  methods: {
    showImgPreview (ind) {
      this.$nextTick(() => {
        const community = document.getElementsByClassName('community')[0]
        community.style.overflow = "hidden";
        community.style.height = "100vh";
        this.$refs.imagePreviewDialog.showPreview(true)
        // this.isShowImagePreview = !this.isShowImagePreview;
        this.showImgInd = ind;
      })
    },
    
    // 点击返回登录
    on_login () {
      sessionStorage.setItem('router_url', this.router_url)//活动详情
      this.$router.push(
        {
          path: '/login/?state=' + 1,
        }
      )
    },


    // 点击头像
    on_ucenter (authorId) {
      // 如果是自己
      if (this.isLogin_user.id && this.isLogin_user.id == authorId) {
        this.$router.push({ path: '/Pcenter?type=0' })
      } else {
        // 如果不是自己
        this.$router.push({ path: '/Ucenter/' + authorId })
        // this.$router.push({
        //   path: '/Ucenter',
        //   query: {
        //     userId: authorId
        //   }
        // })
        // let routeData = this.$router.resolve({ path: '/Ucenter/' + authorId })
        // window.open(routeData.href, '_blank');
      }
    },

    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.isLogin_user = data.user
          this.is_show_common = false

        }
      })
    },

    //作品详情 
    getTopicDetail (name) {
      this.loading = true;
      topicDetail(name).then((res) => {
        let data = res.data;
        this.worksdetail = data.data;
        this.worksdetail.topicTnList.map(i => {
          this.previewList.push(i.topicUrl)
        })
        document.title = '作品详情-' + this.worksdetail.topic.title

        if (data.code == 200) {
          // console.log(this.worksdetail.topic.topicId);
          this.getzaUserLevel(this.worksdetail.topic.topicId);//签约摄影师
          this.commentsparames.topicId = this.worksdetail.topic.topicId;
          this.getSocialShareUrls();//分享
          this.loading = false;
        } else {
          this.$message.error(data.message);

        }

      })
    },


    //获取点赞的签约摄影师
    async getzaUserLevel (topicId) {
      let { data } = await zaUserLevel({
        topicId: topicId
      });
      this.zaUsers = data.data;
    },

    //积分
    post_integral (type) {
      integral(type).then((res) => {
        let data = res.data;
        if (data.status !== 200) {
          this.$message.error(data.message);
        }
      });
    },



    //点赞
    favorfn (id) {
      // 防止重复点击  时间1s
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false
      }, 3000)

      // 未登录就去登录
      if (this.isLogin == true) {
        let params = {
          topicId: id,
        }
        this.like(params)
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },

    // 点赞数据
    like (params) {
      favorTopic(params).then((res) => {
        let data = res.data;
        // if (data.code !== 200) {
        //   this.$message.error(data.message);
        // }
        if (data.code == 200 && data.data.isFavor == 1) {
          this.like_style = true;

          this.$message({
            message: '点赞成功！',
            center: true,
            type: 'success'
          });
          this.worksdetail.topic.favorCount = this.worksdetail.topic.favorCount + 1
          this.worksdetail.isFavor = 1
          // let params_data = {
          //   topicId: this.topicId,
          // }
          // this.getTopicDetail(params_data); //获取详情
          // 请求积分的借口
          let prames = {
            type: '1',
            code: '203',
          }
          this.post_integral(prames);
        }
        if (data.code == 200 && data.data.isFavor == 0) {
          this.like_style = false;
          this.$message({
            message: '取消点赞成功！',
            center: true,
            type: 'success'
          });
          this.worksdetail.isFavor = 0
          this.worksdetail.topic.favorCount = this.worksdetail.topic.favorCount - 1

          // let params_data = {
          //   topicId: this.topicId,
          // }
          // this.getTopicDetail(params_data); //获取详情
          // 请求积分的借口
          let prames = {
            type: '1',
            code: '203',
          }
          this.post_integral(prames);
        }

      })
    },


    //提交评论信息
    submitComment (topId) {
      // 未登录就去登录
      if (this.isLogin == true) {
        let arrlength = this.comments.length;
        let parame = {
          topicId: topId,
          replyContent: this.commentNr
        };
        if (this.commentNr) {
          replyTopic(parame).then((res) => {
            if (res.data.code == 200) {
              let commentsBd = document.getElementById("commentsBd");
              commentsBd.scrollIntoView()//定位到评论
              this.commentNr = "";
              this.pltag = 1;
              this.commentsparames.current = 1;
              this.commentsparames.topicId = topId;
              this.commentsparames.size = arrlength + 1;
              this.$message({
                message: '评论信息提交成功!',
                type: 'success'
              });
              this.loading_bool = false;
              this.comments = [];
              this.getSelectReplise(this.commentsparames);//查看评论接口
              this.worksdetail.topic.replyCount = this.worksdetail.topic.replyCount + 1

              // let params_data = {
              //   topicId: this.topicId
              // }
              // this.getTopicDetail(params_data); //获取详情

              // 请求积分的借口
              let prames = {
                type: '1',
                code: '201',
              }
              this.post_integral(prames);
            } else {
              this.$message({
                message: "评论信息提交失败!",
                type: 'error'
              });
            }

          })
        }
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }

    },

    //获取评论数据
    getSelectReplise (parames) {
      selectReplise(parames).then((res) => {
        this.loading_bool = false;
        this.Replise = res.data.data;
        if (!this.Replise.records) { return };
        this.Replise.records.forEach((item) => {
          this.comments.push(item)
        })
      });
    },
    //加载更多评论
    morecomments (topId) {
      console.log(topId);
      this.loading_bool = true;
      this.commentsparames.topicId = topId;
      this.commentsparames.size = 3;
      this.commentsparames.current = this.commentsparames.current + 1;
      this.getSelectReplise(this.commentsparames);
    },
    // 生成为二维码
    showQRCodes () {
      setTimeout(() => {
        this.url = 'https://v.jingjiribao.cn/newcommunity/#' + this.router_url
        let qrcode = new this.$QRCode("qrcodes", {
          text: this.url, //当前地址栏完整参数
          width: 80,
          height: 80,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: this.$QRCode.CorrectLevel.H
        });
      }, 1000);
    },

    //  分享到qq
    share_qq () {
      const share = {
        title: this.worksdetail.topic.title,
        desc: this.worksdetail.topic.title,
        share_url: window.location.href,
      };
      window.open("https://connect.qq.com/widget/shareqq/index.html?url=" + encodeURIComponent(share.share_url) + "&title=" + share.title + "&desc=" + share.desc);
    },

    //  分享到微博
    share_wb () {
      const share = {
        title: this.worksdetail.topic.title,
        desc: this.worksdetail.topic.title,
        share_url: window.location.href,
        // image_url: this.details_son.activityUrl,
      };
      window.open('https://service.weibo.com/share/share.php?url=' + encodeURIComponent(share.share_url) + '&title=' + share.title + '&pic=' + share.image_url + '&searchPic=true');
    },

    // 分享
    getSocialShareUrls () {
      let info = {
        url: this.url,
        title: `中经视觉-${this.worksdetail.topic.title}`,
        source: `中经视觉-${this.worksdetail.topic.title}`,
        desc: `中经视觉-${this.worksdetail.topic.title}`,
        image: `中经视觉-${this.worksdetail.topic.title}`,
        summary: `中经视觉-${this.worksdetail.topic.title}`
      };
      ["qq", "wx", "wb", "kj"].forEach(v => {
        this.share[v] = socialShare(v, info);
      });
    },
    //滚动到指定的位置
    getScroll () {
      let share = document.getElementById("share");
      share.scrollIntoView()
    }
  },
}
</script>
<style lang="scss" scoped="scoped">
@import "../../../assets/css/community/findDetail";

img[lazy="loading"] {
  display: block;
  width: 0.5rem !important;
  height: 0.5rem !important;
  margin: 0 auto;
}

.like {
  background: url("../../../assets/image/community/za.png") center -20px no-repeat !important;
}
div.state {
  padding-top: 0 !important;
  display: flex;
  align-items: flex-end;

  ul {
    display: -webkit-box;
    display: -ms-flexbox;
    height: 100%;
    display: flex;
    align-items: flex-end;
    width: 340px;
    justify-content: space-around;
    li {
      display: flex;
      align-items: center;
      text-align: center;
      color: #999;
      color: #bbb;
      width: 93px;
      justify-content: center;
      &.solid {
        width: 10px;
        flex-grow: 0;
        color: #d9d9d9;
      }
      i {
        display: inline-block;
        width: 40px;
        height: 20px;
        vertical-align: middle;
        margin-top: -2px;
        transition: all 0.3s;
      }
      // 预览
      &:nth-of-type(1) i {
        background: url("../../../assets/image/community/see.png") center 0
          no-repeat;
      }
    }
    li:nth-of-type(4) {
      width: 60px !important;
    }
  }
}

.state b {
  color: #999;
  margin: 0 10px;
  height: 100%;
}

// 评论
.common i {
  background: url("../../../assets/image/community/msg.png") center 0 no-repeat;
}
.common:hover i {
  background: url("../../../assets/image/community/msg.png") center -20px no-repeat;
}
// 点赞
.like_son i {
  background: url("../../../assets/image/community/za.png") center 0 no-repeat;
}
// 默认点赞
.like_son:hover i {
  background: url("../../../assets/image/community/za.png") center -20px no-repeat;
}

.share:hover {
  cursor: pointer;
}
// 分享
.share i img {
  width: 20px;
  // width: 100%;
  // background: url("../../../assets/image/community/finddetailshare.png");
}

.state li:nth-child(2):hover,
.state li:nth-child(3):hover {
  color: #c00;
  cursor: pointer;
}

.photo {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/community/findDetail/findDetail.vue